var modules_cc53b92d = {"menuTitle":"SuggestList_module_menuTitle__85abf544","menuContent":"SuggestList_module_menuContent__85abf544","menuItem":"SuggestList_module_menuItem__85abf544","focused":"SuggestList_module_focused__85abf544","menuItemLabel":"SuggestList_module_menuItemLabel__85abf544","menuItemIcon":"SuggestList_module_menuItemIcon__85abf544"};
import "../../assets/esm/components/SuggestList/index~BEw8hbqc.css";

export { modules_cc53b92d as default };
//# sourceMappingURL=SuggestList.module.less.js.map
